import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deletePlanoContaCadastro } from '../service';
import {
  DELETE_PLANO_CONTA_CADASTRO,
  DELETE_PLANO_CONTA_CADASTRO_PENDING,
  DELETE_PLANO_CONTA_CADASTRO_SUCCESS,
  DELETE_PLANO_CONTA_CADASTRO_FAILURE,
} from '../actionTypes';

import { AlertError } from '@components/common/AlertToast'
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaDeletePlanoContaCadastro(action) {
  yield put({ type: DELETE_PLANO_CONTA_CADASTRO_PENDING, id: action.id })

  trackingEventCX('action', MODULE_ACTIONS_ENUM.PLANO_CONTAS_GERENCIAL_EXCLUIR);

  try {
    const a = yield call(deletePlanoContaCadastro, action.id);

    if (a.status !== 204) {
      throw new Error('API delete request failed');
    }
    yield put({ type: DELETE_PLANO_CONTA_CADASTRO_SUCCESS, id: action.id });

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {

    yield put({ type: DELETE_PLANO_CONTA_CADASTRO_FAILURE });

    AlertError('Falha ao excluir o registro! Verifique se a conta não possui vínculo com outra conta gerencial ou em lançamentos no financeiro.');
  }
}

export default function* watchDeletePlanoContaCadastro() {
  yield takeLatest(DELETE_PLANO_CONTA_CADASTRO, sagaDeletePlanoContaCadastro)
}
